import React from 'react';
import { Loader2, Lock, Mail } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SubPageLayout from './SubPageLayout';

const GoogleMark = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.6 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6C12.3 13.6 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.4 5.7c4.3-4 7.2-9.9 7.2-17.4z" />
    <path fill="#FBBC05" d="M10.4 28.8A14.5 14.5 0 0 1 9.5 24c0-1.7.3-3.3.8-4.8l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.8-6z" />
    <path fill="#34A853" d="M24 48c6.2 0 11.6-2 15.4-5.6l-7.4-5.7c-2 1.4-4.7 2.3-8 2.3-6.3 0-11.7-4.1-13.6-9.8l-7.8 6C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

export const GoogleSignInButton = ({ className = 'btn-cta', style, testId = 'google-signin-btn', label = 'Sign in with Google' }) => {
  const { loginUrl } = useAuth();
  return (
    <a href={loginUrl()} className={`${className} whitespace-nowrap`} style={style} data-testid={testId}>
      <GoogleMark />
      {label}
    </a>
  );
};

const SignInGate = ({ title, description }) => {
  const { pathname } = useLocation();
  return (
  <SubPageLayout>
    <section className="py-24 lg:py-32" data-testid="signin-gate">
      <div className="max-w-xl mx-auto px-4 text-center">
        <div className="w-14 h-14 bg-[#0d1b2e] flex items-center justify-center mx-auto mb-6" style={{ borderRadius: '2px' }}>
          <Lock className="w-6 h-6 text-white" />
        </div>
        <p className="section-marker justify-center">§ Coaches &amp; Team Access</p>
        <h1 className="section-heading mb-4">{title}</h1>
        <p className="text-[#2a3950] text-base leading-relaxed mb-8">{description}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a href={`/login?next=${encodeURIComponent(pathname)}`} className="btn-cta whitespace-nowrap" data-testid="signin-gate-email-btn">
            <Mail className="w-4 h-4" /> Sign in with email
          </a>
          <GoogleSignInButton className="btn-cta-ghost" testId="signin-gate-google-btn" />
        </div>
        <p className="mono text-[0.72rem] text-[#5b6b82] mt-6" style={{ letterSpacing: '0.14em', textTransform: 'uppercase' }}>Staff accounts · @integratedwellnessny.com</p>
      </div>
    </section>
  </SubPageLayout>
  );
};

export const ProtectedRoute = ({ children, title, description }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--paper)]" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 text-[#b91c1c] animate-spin" />
      </div>
    );
  }
  if (!user) return <SignInGate title={title} description={description} />;
  return children;
};
